<div class="recorder-wrapper">
    <ng-container *ngIf="isAllValuesEmpty(setData)">
        <div class="recorder-container">
            <ng-container *ngIf="!recordingStarted && !ResetRecording">
                <img [src]="isVideo ? 'assets/cam.png' : 'assets/audio.png'" class="icon d-block mx-auto" />

                <button class="btn btn_previous py-1" (click)="startRecording()" [ngStyle]="{'background': nextButton}">
                    <i class="fa fa-circle clr_red mr-1"></i> Record {{ isVideo ? 'Video' : 'Audio' }}
                </button>
            </ng-container>

            <div *ngIf="recordingStarted" class="controls">
                <!-- disablePictureInPicture -->
                <p class="timer" *ngIf="recordingStarted && !recordingStopped">{{ timerDisplay }}</p>
                <video *ngIf="isVideo" #video playsinline class="media-display"
                    (loadedmetadata)="onLoadedMetadata(video)">
                </video>


                <div class="gap-4 mt-2" *ngIf="hideFunctions == false">
                    <button *ngIf="!isPaused" class="btn btn_previous mr-2 py-1 mb-2" title="Pause"
                        (click)="pauseRecording()" [ngStyle]="{'background': nextButton}">
                        <i class="fa fa-pause clr_white"></i>
                    </button>

                    <button *ngIf="isPaused" class="btn btn_previous mr-2 py-1 mb-2" title="Resume"
                        (click)="resumeRecording()" [ngStyle]="{'background': nextButton}">
                        <i class="fa fa-play clr_white"></i>
                    </button>
                    <br>
                    <button class="btn btn_previous py-1 mb-2" (click)="stopAutoRecording()"
                        [ngStyle]="{'background': nextButton}">
                        <i class="fa fa-stop clr_red mr-1"></i> Click here to submit</button>
                </div>

            </div>
            <div *ngIf="ResetRecording" class="mt-2">

                <audio *ngIf="!isVideo" #audio controls class="media-display"
                    (loadedmetadata)="onLoadedMetadata(audio)">
                </audio>



                <button class="btn btn_previous py-1 mb-2" (click)="resetRecording()"
                    [ngStyle]="{'background': nextButton}">
                    <i class="fa fa-refresh clr_white mr-1"></i> Reset
                </button>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="hasNonEmptyValue(setData)">
        <h5>Your response to this question has already been captured.</h5>
    </ng-container>
</div>




<!-- Auto Stop Recording Message Modal -->
<!-- Modal Structure (Centered using Bootstrap classes) -->
<div *ngIf="autoStopModal" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0, 0, 0, 0.5);">
    <div class="modal-dialog mt_10 modal-md">
        <div class="modal-content">
            <div class="modal-body text-center p-4 d-block">
                <p class="mb-4">
                    Your recording time is complete. Please click next to proceed or click reset if you wish to restart
                    the recording.
                </p>
                <div class="d-flex justify-content-center mt-4">
                    <button type="button" class="btn custom-button" (click)="closeAutoStopModal()">

                        OK
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>